// Generated by scripts/sync-l10n.mjs. Do not edit by hand.
import en from './locales/en.json';
import es from './locales/es.json';
import zh from './locales/zh.json';

export const supportedLocales = ['en', 'es', 'zh'] as const;

export type SupportedLocale = (typeof supportedLocales)[number];

export const resources = {
  en: { translation: en },
  es: { translation: es },
  zh: { translation: zh },
} as const;
